
      import API from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.91.0_@swc+core@1.6.1_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.91.0_@swc+core@1.6.1_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.91.0_@swc+core@1.6.1_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.91.0_@swc+core@1.6.1_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/setAttributesWithAttributesAndNonce.js";
      import insertStyleElement from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.91.0_@swc+core@1.6.1_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../node_modules/.pnpm/style-loader@3.3.4_webpack@5.91.0_@swc+core@1.6.1_webpack-cli@5.1.4_/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0_@swc+core@1.6.1_webpack-cli@5.1.4_/node_modules/css-loader/dist/cjs.js!../../../../node_modules/.pnpm/sass-loader@12.6.0_node-sass@9.0.0_sass@1.77.2_webpack@5.91.0_@swc+core@1.6.1_webpack-cli@5.1.4_/node_modules/sass-loader/dist/cjs.js!./index.scss";
      
      

var options = {"attributes":{"id":"shell-main-css"}};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0_@swc+core@1.6.1_webpack-cli@5.1.4_/node_modules/css-loader/dist/cjs.js!../../../../node_modules/.pnpm/sass-loader@12.6.0_node-sass@9.0.0_sass@1.77.2_webpack@5.91.0_@swc+core@1.6.1_webpack-cli@5.1.4_/node_modules/sass-loader/dist/cjs.js!./index.scss";
       export default content && content.locals ? content.locals : undefined;
